// make e2 to be seen when 1 vCPU

const _vmDecision: any = {
  maxResults: 3,
  extendValues: [
    "E2 Shared Core",
    "E2",
    "N1",
    "T2D",
    "N2",
    "N2D",
    "C2",
    "A2",
    "M1",
    "M2",
  ],
  recommendationOrder: [
    ["N2", "N2D"],
    "E2",
    "T2D",
    "C2",
    ["M1", "M2"],
    ["A2", "N1"],
    "E2 Shared Core",
  ],
  groups: [
    {
      type: "open",
      qq: [
        {
          text: "Amount of vCPU",
          orderNumber: 1,
          key: "cpu",
          note: "",
          type: "slider",
          noExtend: ["[-1,1]", "[0,1]"],
          settings: {
            default: 2,
            range: [1, 225],
            labels: ["<2 vCPU", ">224 vCPU"],
            out: "eval: ({v, d}) => (v > 224) ? ({v: 224, d: 'vCPU'}) : ({v, d: 'vCPU'})",
            in: "eval: ({v, d}) => ({v, d})",
          },
          optionsRange: [
            {
              range: [0, 1],
              res: ["E2", "T2D"],
            },
            {
              range: [2, 3],
              res: ["E2", "N2", "N2D"],
            },
            {
              range: [4, 32],
              res: ["E2", "N2", "N2D", "C2"],
            },
            {
              range: [33, 39],
              res: ["N2", "N2D", "T2D", "C2"],
            },
            {
              range: [40, 60],
              res: ["N2", "N2D", "T2D", "C2", "M1"],
            },
            {
              range: [61, 79],
              res: ["N2", "N2D", "M1"],
            },
            {
              range: [80, 159],
              res: ["N2D", "M1"],
            },
            {
              range: [160, 224],
              res: ["N2D", "M2"],
            },
            {
              range: [225, 225],
              res: ["M2"],
            },
          ],
        },
        {
          text: "Amount of Memory",
          orderNumber: 2,
          key: "memory",
          note: "",
          type: "slider",
          settings: {
            default: 4,
            range: [2, 786],
            labels: ["<128 GB", ">786 GB"],
            out: "eval: ({v, d}) => ({v, d: 'GB'})",
            in: "eval: ({v, d}) => ({v, d: 'GB'})",
          },
          optionsRange: [
            {
              range: [0, 3],
              res: ["E2", "N2", "N2D"],
            },
            {
              range: [4, 128],
              res: ["E2", "N2", "N2D", "T2D"],
            },
            {
              range: [129, 240],
              res: ["N2", "N2D", "T2D", "C2"],
            },
            {
              range: [241, 640],
              res: ["N2", "N2D"],
            },
            {
              range: [641, 786],
              res: ["N2D"],
            },
          ],
        },
        {
          text: "Amount of Memory",
          orderNumber: 2,
          key: "memory-extended",
          note: "",
          type: "slider",
          visible: false,
          settings: {
            default: 4,
            range: [2, 12000],
            labels: ["<128 GB", ">12 TB"],
            out: "eval: ({v, d}) => (v < 786) ? ({v, d: 'GB'}) : ({v: Math.ceil(v/1000), d: 'TB'})",
            in: "eval: ({v, d}) => (d === 'GB') ? ({d, v}) : ({d, v: v * 1000})",
          },
          optionsRange: [
            {
              range: [0, 3],
              res: ["E2", "N2", "N2D"],
            },
            {
              range: [4, 128],
              res: ["E2", "N2", "N2D", "T2D"],
            },
            {
              range: [129, 240],
              res: ["N2", "N2D", "T2D", "C2"],
            },
            {
              range: [241, 640],
              res: ["N2", "N2D"],
            },
            {
              range: [641, 786],
              res: ["N2D"],
            },
            {
              range: [787, 4000],
              res: ["M1", "M2"],
            },
            {
              range: [4001, 12000],
              res: ["M2"],
            },
          ],
        },
        {
          text: "Extend memory",
          orderNumber: 3,
          key: "extend-memory",
          note: "",
          type: "checkbox",
          extend: false,
          settings: {
            default: "unchecked",
          },
          optionsValue: {
            checked: "bundle:[memory-extended]",
            unchecked: "bundle:[memory]",
          },
        },
        {
          text: "What will run on this VM ",
          orderNumber: 3,
          key: "load-type",
          note: "",
          type: "dropdown",
          settings: {
            values: ["Other", "AI/ML", "HPC"],
            default: "Other",
          },
          optionsValue: {
            "AI/ML": "bundle:[gpu-need]",
            HPC: "bundle:[gpu-need]",
            Other: [],
          },
        },
        {
          text: "Do you need GPUs?",
          orderNumber: 4,
          visible: false,
          key: "gpu-need",
          note: "",
          type: "checkbox",
          extend: false,
          settings: {
            default: "unchecked",
          },
          optionsValue: {
            checked: "bundle:[gpu-type]",
            unchecked: ["C2", "T2D", "A2", "M1", "M2"],
          },
        },
        {
          text: "What kind of GPU?",
          orderNumber: 5,
          visible: false,
          key: "gpu-type",
          note: "",
          type: "dropdown",
          final: ["A100", "T4", "V100"],
          settings: {
            values: ["A100", "T4", "V100"],
            default: "A100",
          },
          optionsValue: {
            A100: ["A2"],
            T4: ["N1"],
            V100: ["N1"],
          },
        },
        {
          text: "Do you need block storage (PD and local SSD)?",
          orderNumber: 7,
          key: "bs-need",
          note: "",
          type: "checkbox",
          settings: {
            default: "unchecked",
          },
          optionsValue: {
            checked: "bundle:[bs-type]",
            unchecked: [],
          },
        },
        {
          text: "What kind of  throughput do you need for block storage?",
          orderNumber: 8,
          key: "bs-type",
          note: "",
          type: "dropdown",
          extend: false,
          visible: false,
          settings: {
            values: [
              "<80k (Balanced)",
              "up to 100K IOPS. (Performance)",
              "up to 120K IOPS (Extreme)",
              "up to 2.4M IOPS (Local SSD)",
            ],
            default: "<80k (Balanced)",
          },
          optionsValue: {
            "<80k (Balanced)": [
              "E2",
              "N1",
              "N2",
              "N2D",
              "C2",
              "A2",
              "M1",
              "M2",
            ],
            "up to 100K IOPS. (Performance)": [
              "E2",
              "N1",
              "N2",
              "N2D",
              "C2",
              "A2",
              "M1",
              "M2",
            ],
            "up to 120K IOPS (Extreme)": ["N2", "M1", "M2"],
            "up to 2.4M IOPS (Local SSD)": ["N2", "N2D", "C2", "M1", "A2"],
          },
        },
      ],
    },
    {
      type: "additional",
      label: "Show more questions",
      qq: [
        {
          text: "Do you need in-memory encryption; Confidential Compute?",
          orderNumber: 8,
          key: "mem-encryption-need",
          note: "",
          type: "dropdown",
          final: ["Yes"],
          settings: {
            default: "Not sure",
            values: ["Not sure", "Yes", "No"],
          },
          optionsValue: {
            "Not sure": [],
            Yes: ["N2D"],
            No: ["E2", "N2", "C2", "T2D"],
          },
        },
        {
          text: "Processor type?",
          orderNumber: 9,
          key: "mem-encryption-proc",
          note: "",
          type: "dropdown",
          extend: false,
          settings: {
            values: ["No preference", "Intel", "AMD"],
            default: "No preference",
          },
          optionsValue: {
            "No preference": [],
            Intel: ["E2", "N2", "C2", "M1", "M2"],
            AMD: ["E2", "N2D", "T2D"],
          },
        },
        {
          text: "Application sensitivity to performance fluctuations",
          orderNumber: 10,
          key: "mem-encryption-performance",
          note: "",
          type: "dropdown",
          settings: {
            values: [
              "Not sure",
              "Low/not important",
              "Medium",
              "High",
              "Very Sensitive",
            ],
            default: "Not sure",
          },
          optionsValue: {
            "Not sure": ["E2", "N2", "N2D", "T2D", "C2", "M1", "M2"],
            "Low/not important": ["E2", "N2", "N2D", "T2D", "C2", "M1", "M2"],
            Medium: ["N2", "N2D", "T2D", "C2", "M1", "M2"],
            High: ["C2", "M1", "M2"],
            "Very Sensitive": ["C2", "M1", "M2"],
          },
        },
      ],
    },
  ],
  info: [
    {
      key: "N2",
      title: "N2",
      info: [
        {
          type: "text",
          text: "General purpose",
        },
        {
          type: "note",
          text: "Balanced price/performance across a wide range of VM shapes",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "2 - 80",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "2 - 640 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "10-100 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "Yes",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "Cascade Lake, Ice Lake",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Web serving, App serving, Back office applications, Medium-large databases, Cache, Media/streaming",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "C2",
      title: "C2",
      info: [
        {
          type: "text",
          text: "Compute Optimized",
        },
        {
          type: "note",
          text: "Ultra high performance for compute-intensive workloads",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "4 - 60",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "16 - 240 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "10-100 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "Yes",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "Cascade Lake",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Compute-bound workloads, High-performance web serving, Gaming (AAA game servers), Ad serving, High-performance computing (HPC), Media transcoding, AI/ML",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "N2D",
      title: "N2D",
      info: [
        {
          type: "text",
          text: "General purpose",
        },
        {
          type: "note",
          text: "Balanced price/performance across a wide range of VM shapes",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "2 - 224",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "2 - 786 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "32 - 100 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "Yes",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "AMD EPYC Rome, AMD EYPC Milan",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Web serving, App serving, Back office applications, Medium-large databases, Cache, Media/streaming",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "M1",
      title: "M1",
      info: [
        {
          type: "text",
          text: "Memory optimized",
        },
        {
          type: "note",
          text: "Ultra high-memory workloads",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "40 - 160",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "961 - 3844 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "32 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "Yes / No",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "Skylake / Broadwell E7",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Medium-large in-memory databases such as SAP HANA, In-memory databases and in-memory analytics, Microsoft SQL Server and similar databases",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "M2",
      title: "M2",
      info: [
        {
          type: "text",
          text: "Workload optimized",
        },
        {
          type: "note",
          text: "Ultra high-memory workloads",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "208 - 416",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "5,888 - 11,776 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "32 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "Cascade Lake",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Medium-large in-memory databases such as SAP HANA, In-memory databases and in-memory analytics, Microsoft SQL Server and similar databases",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "E2",
      title: "E2",
      info: [
        {
          type: "text",
          text: "General purpose. Both: AMD and Intel, cannot be specified",
        },
        {
          type: "note",
          text: "Day-to-day computing at lower cost",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "2 - 32",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "8 - 128 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "16 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "Skylake / Broadwell / Haswell / AMD EPYC Rome",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Web serving, App serving, Back office applications, Small-medium database, Microservices, Virtual desktops, Development environments",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "N1",
      title: "N1",
      info: [
        {
          type: "text",
          text: "General purpose",
        },
        {
          type: "note",
          text: "Balanced price/performance across a wide range of VM shapes",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "1 - 96",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "0.60 - 624 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "32 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "Yes / No",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "Yes",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value:
                    "Skylake / Broadwell / Haswell / Sandy Bridge / Ivy Bridge",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Web serving, App serving, Back office apps, Medium-large databases, Cache, Media/streaming",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "A2",
      title: "A2",
      info: [
        {
          type: "text",
          text: "Workload optimized",
        },
        {
          type: "note",
          text: "Optimized for high performance computing workloads",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "12 - 96",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "85 - 1360 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "100 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "Yes",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "Yes",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "Cascade Lake",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "CUDA-enabled ML training and inference, HPC, Massive parallelized computation",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "E2 Shared-core",
      title: "E2 Shared-core",
      info: [
        {
          type: "text",
          text: "General purpose",
        },
        {
          type: "note",
          text: "Day-to-day computing at a lower cost",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "0.25 - 1",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "1 - 4 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "3 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "2 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "Skylake / Broadwell / Haswell / AMD EPYC Rome",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Web serving, App serving, Back office apps, Small-medium databases, Microservices, Virtual desktops, Development environments",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
    {
      key: "T2D",
      title: "T2D",
      info: [
        {
          type: "text",
          text: "Cloud Native applications",
        },
        {
          type: "note",
          text: "The highest performance/core in Public cloud",
        },
        {
          type: "group",
          title: "Show more",
          controls: [
            {
              type: "table",
              rows: [
                {
                  type: "table-row",
                  name: "vCPUs",
                  value: "1 - 60",
                },
                {
                  type: "table-row",
                  name: "Memory",
                  value: "4 - 240 GB",
                },
                {
                  type: "table-row",
                  name: "Maximum total PD size",
                  value: "257 TB",
                },
                {
                  type: "table-row",
                  name: "Maximum egress bandwidth",
                  value: "32 Gbps",
                },
                {
                  type: "table-row",
                  name: "Local SSDs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "GPUs",
                  value: "No",
                },
                {
                  type: "table-row",
                  name: "CPU platform",
                  value: "AMD EPYC™ Milan",
                },
              ],
            },
            {
              type: "note",
              text: "Recommended for the following workloads",
            },
            {
              type: "text",
              text: "Backend and/or bursty batch, Interactive webserving, Highend DBs, Media Transcoding, In memory analytics, Java and Python applications",
            },
            {
              type: "link",
              text: "Learn more",
              href: "https://cloud.google.com/compute/docs/machine-types",
            },
          ],
        },
      ],
    },
  ],
};

export const vmDecision = () => JSON.parse(JSON.stringify(_vmDecision));
